import { Button, Col, Row, Typography } from 'antd';

interface Props {
  rowData: any;
  count: number;

  page: number;
  fromDt: string;
  toDt: string;
  filterState: string;
  filterInput: string;
}

const TransactionList = ({
  rowData,
  count,

  page,
  fromDt,
  toDt,
  filterState,
  filterInput
}: Props) => {
  const handleOnExport = async () => {
    console.log('HIHI');
  };
  return (
    <div className="busk-sellerSubHead">
      <Row align="middle">
        <Col flex="auto">
          <Row gutter={15}>
            <Col>
              <Typography.Text>총 포워딩 업체 {count ?? '00'}</Typography.Text>
            </Col>
          </Row>
        </Col>
        <Col>
          <Button
            style={{
              color: 'gray'
            }}
            onClick={() => handleOnExport()}
          >
            포워딩 업체 등록
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default TransactionList;
